import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { FaHtml5, FaCss3Alt, FaJs, FaReact, FaNodeJs, FaGitAlt, FaDatabase, FaServer, FaMobile, FaDesktop } from "react-icons/fa";
import "./Skills.css";

const Skills: React.FC = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const skills = [
    {
      name: "JavaScript",
      icon: <FaJs />,
      category: "Frontend",
      level: 85,
      description: "Lenguaje de programación principal para desarrollo web",
    },
    {
      name: "HTML5",
      icon: <FaHtml5 />,
      category: "Frontend",
      level: 90,
      description: "Marcado semántico y estructura web",
    },
    {
      name: "CSS3",
      icon: <FaCss3Alt />,
      category: "Frontend",
      level: 75,
      description: "Estilos y diseño responsive",
    },
    {
      name: "React",
      icon: <FaReact />,
      category: "Frontend",
      level: 80,
      description: "Biblioteca para interfaces de usuario",
    },
    {
      name: "Node.js",
      icon: <FaNodeJs />,
      category: "Backend",
      level: 83,
      description: "Runtime de JavaScript para servidores",
    },
    {
      name: "DOM",
      icon: <FaDesktop />,
      category: "Frontend",
      level: 83,
      description: "Manipulación del DOM y eventos",
    },
  ];

  return (
    <section id="skills" className="skills">
      <div className="skills-container">
        <motion.div ref={ref} className="skills-content" initial={{ opacity: 0, y: 50 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.8 }}>
          <motion.h2 className="section-title" initial={{ opacity: 0, y: 30 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.8, delay: 0.2 }}>
            Mis Habilidades
          </motion.h2>

          <motion.p className="skills-description" initial={{ opacity: 0, y: 30 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.8, delay: 0.4 }}>
            Tecnologías y herramientas que utilizo para crear aplicaciones web modernas y funcionales.
          </motion.p>

          <div className="skills-grid">
            {skills.map((skill, index) => (
              <motion.div key={skill.name} className="skill-card" initial={{ opacity: 0, y: 30 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.8, delay: 0.2 + index * 0.1 }} whileHover={{ scale: 1.05 }}>
                <div className="skill-icon">{skill.icon}</div>
                <h3>{skill.name}</h3>
                <p className="skill-category">{skill.category}</p>
                <p className="skill-description">{skill.description}</p>
                <div className="skill-level">
                  <div className="skill-bar">
                    <motion.div className="skill-progress" initial={{ width: 0 }} animate={inView ? { width: `${skill.level}%` } : {}} transition={{ duration: 1, delay: 0.5 + index * 0.1 }} />
                  </div>
                  <span className="skill-percentage">{skill.level}%</span>
                </div>
              </motion.div>
            ))}
          </div>

          <motion.div className="skills-summary" initial={{ opacity: 0, y: 50 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.8, delay: 0.8 }}>
            <h3>Especialidades</h3>
            <div className="specialties-grid">
              <div className="specialty-item">
                <FaDesktop />
                <h4>Desarrollo Frontend</h4>
                <p>Interfaces de usuario modernas y responsivas</p>
              </div>
              <div className="specialty-item">
                <FaServer />
                <h4>Desarrollo Backend</h4>
                <p>APIs robustas y arquitecturas escalables</p>
              </div>
              <div className="specialty-item">
                <FaMobile />
                <h4>Diseño Responsive</h4>
                <p>Experiencias optimizadas para todos los dispositivos</p>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Skills;
